import { render, staticRenderFns } from "./knowledgeSummaryNotice.vue?vue&type=template&id=3e905709&scoped=true"
import script from "./knowledgeSummaryNotice.vue?vue&type=script&lang=js"
export * from "./knowledgeSummaryNotice.vue?vue&type=script&lang=js"
import style0 from "./knowledgeSummaryNotice.vue?vue&type=style&index=0&id=3e905709&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e905709",
  null
  
)

export default component.exports